import { OreTooltip } from "@edenredespana/oreneta";
import { useLayoutEffect, useRef, useState } from "react";
import { DROPDOWN_STYLES } from "./constants/styles";

export const TruncatedTooltip = ({ text, ...spanProps }: { text: string }) => {
  const spanRef = useRef<HTMLSpanElement>(null);
  const [truncated, setTruncated] = useState(false);

  useLayoutEffect(() => {
    const el = spanRef.current;
    if (el) {
      setTruncated(el.scrollWidth > el.clientWidth);
    }
  }, [text]);

  const span = (
    <span
      ref={spanRef}
      style={DROPDOWN_STYLES.truncatedTooltipText}
      {...spanProps}
    >
      {text}
    </span>
  );

  return truncated ? (
    <OreTooltip text={text} placement="top">{span}</OreTooltip>
  ) : (
    span
  );
};